
import { Component, Vue } from 'vue-property-decorator'
import { DriverDynamicClient, DriverClient } from '@/api'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
import moment from 'moment'
@Component({
  name: 'DriverDynamicList',
  components: {
  }
})
export default class extends BaseList {
  private driverClient = new DriverClient()
  private driverList = []
  public constructor() {
    super()
    this.client = new DriverDynamicClient()
    this.listQuery = {
      filter: {
        where: {
          description: { like: '' },
          createdAt: { begin: undefined, end: undefined },
          driverId: undefined
        },
        fields: {
          id: true,
          driverId: true,
          gasType: true,
          floating_ratio: true,
          volume: true,
          gasPrice: true,
          out: true,
          in: true,
          balance: true,
          description: true,
          createdAt: true
        },
        include: [
          { relation: 'driver' },
          { relation: 'stationDynamic' }
        ],
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
    await this.getDriverList()
  }

  private async getDriverList() {
    this.driverList = await this.driverClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          mobile_phone_number: true
        },
        order: ['createdAt']
      }
    })
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    const and = []
    if (!_.isNil(t.filter.where.description) && !_.isEmpty(t.filter.where.description)) {
      and.push({ description: { like: `%${t.filter.where.description.like}%` } })
    }

    const createdAt = t.filter.where.createdAt
    if (createdAt.begin) {
      and.push({ createdAt: { gte: moment(createdAt.begin).utcOffset(480) } })
    }

    if (createdAt.end) {
      and.push({ createdAt: { lt: moment(createdAt.end).utcOffset(480) } })
    }

    if (_.isNumber(t.filter.where.driverId)) {
      and.push({ driverId: t.filter.where.driverId })
    }
    t.filter.where = { and }
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val:number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val:number) {
    super.handleCurrentChange(val)
  }

  protected handleDownload() {
    this.listLoading = true
    const header = ['订单编号', '姓名', '类型', '浮动比例', '加气量', '气价', '收入', '支出', '账户余额', '备注', '时间']
    const filterVal = ['stationDynamic.id', 'driver.name', 'gasType', 'floating_ratio', 'volume', 'gasPrice', 'in', 'out', 'balance', 'description', 'createdAt']
    const data = _.union([header], this.formatJson(filterVal, this.list))
    this.exportXlsx(data)
    this.listLoading = false
  }

  protected formatJson(filterVal :any, jsonData:any) {
    const data = jsonData.map((v:any) => filterVal.map((j:any) => {
      if (j === 'createdAt') {
        return this.parseTime(v[j])
      } else if (j === 'driver.name') {
        if (v['driver']) {
          return v['driver']['name']
        } else {
          return '司机已删除'
        }
      } else if (j === 'stationDynamic.id') {
        if (v['stationDynamic']) {
          return v['stationDynamic']['id']
        } else {
          return ''
        }
      } else {
        return v[j]
      }
    }))
    return data
  }
}
